module.exports = __webpack_public_path__ + "img/svg/banner-card.e9a2b906852243f5168de2b4c1277963.svg";